import React from 'react'

import Map from '../../map'

export default props => <Map track={(props.formContext || {}).track} {...props} />
